module.exports = __webpack_public_path__ + "img/AI.c17b3dda.svg";